<template>
  <div class="modal-file" :class="{'open': modal}" @click="closeModal">
    <div class="modal-file-inner">
      <div class="col-file">
        <label class="btn btn-danger btn-file" title="Documentos">
          <input type="file" class="d-none" @change="handleFileChange($event);" accept="application/pdf"><i class="fa fa-file-alt"></i>
        </label>
        <div class="small mt-2 d-md-none">Arquivo</div>
      </div>
      <div class="col-file">
        <label class="btn btn-info btn-file" title="Galeria">
          <input type="file" class="d-none" @change="handleFileChange($event);" accept="image/*"><i class="fa fa-image"></i>
        </label>
        <div class="small mt-2 d-md-none">Galeria</div>
      </div>
      <div class="col-file">
        <label class="btn btn-warning text-white btn-file" title="Câmera">
          <input type="file" class="d-none" @change="handleFileChange($event);" accept="image/*" capture="user"><i class="fa fa-camera"></i>
        </label>
        <div class="small mt-2 d-md-none">Câmera</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalFile',
  data() {
    return {
      modal: false
    }
  },

  methods: {
    handleFileChange(event) {         
      let selectedFile = event.target.files[0];
      this.$emit('receiveDocumentToSend', selectedFile);      
    },

    closeModal() {
      document.body.classList.remove("modal-open");
      this.modal = false;
    },

    openModal() {
      document.body.classList.add("modal-open");
      this.modal = true;
    }
  },

  created() {
    this.$parent.$on('openModalFile', (url) => {
      this.openModal();
    });
  }
}
</script>

<style scoped>
.modal-file {
  opacity: 0;
  visibility: hidden;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  text-align: left;
  transition: opacity .25s ease;
  z-index: 1090;
}

.modal-file.open {
  opacity: 1;
  visibility: visible;
}

.modal-file-inner {
  transition: top .25s ease;
  position: absolute;
  margin: auto;
  overflow: hidden;
  padding: 32px 0;
  right: 56px;
  bottom: 42px;
  text-align: center;
}

.col-file {
  padding: 6px 12px;
}

.btn-file {
  margin: auto;
  height: 52px;
  width: 52px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

@media screen and (max-width: 767px) {
  .modal-file-inner {
    border-radius: 6px;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
    background: rgba(255,255,255);
    padding: 15px;
    width: 96%;
    left: 2%;
    right: 2%;
    bottom: 82px;
    display: flex;
    justify-content: space-between;
  }

  .btn-file {
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
  }
}
</style>
